import React, { memo } from 'react';
import { Button, Box } from '@material-ui/core';
import { MeusPedidosDesktopIcon } from 'utils/Icons/meus-pedidos-icon-desktop';
import { MeusPedidosIcon } from 'utils';
import { useStyles } from './button-resumo-pedido-styles';
import { useThemeQueries } from 'components/dialogs/dialog-adicionar-produto-com-subitem/util-styles';
import { EnumModals, useModalStore } from 'services/store/modal-store';
import { useCardapioDadosStore } from 'services/store/cardapio-dados-store';

export interface ButtonResumoPedidoProps {
    abrirPedidoResumo: () => void;
}

export const ButtonResumoPedido = memo(({
    abrirPedidoResumo: abrirPedido,
    ...props
}: ButtonResumoPedidoProps) => {
    const { isMobile, theme } = useThemeQueries()
    const configuracoes = useCardapioDadosStore(state => state.cardapioDados?.configuracoes)
    const classes = useStyles();

    const { openCloseModal } = useModalStore(state => state);
    const abrirPedidoResumo = () => {
        if (configuracoes?.tipoUsoCardapio === 1) {
            abrirPedido()
            return
        }
        openCloseModal(EnumModals.ResumoPedido, true);
    }
    return (
        <>
            {isMobile ? (
                <Box style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    height: 50,
                    width: 50,
                    marginLeft: theme.spacing(2)
                }}>
                    <Button
                        className={classes.containerMeusPedidos}
                        onClick={abrirPedidoResumo}
                        variant="contained"
                        size="large"
                    >
                        <MeusPedidosIcon tipo='BUTTON_MEU_PEDIDO' />
                    </Button>
                </Box>
            ) : (
                <Box style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}>
                    <Button
                        className={classes.containerMeusPedidos}
                        onClick={abrirPedidoResumo}
                        variant="contained"
                        size="medium"
                        fullWidth
                    >
                        <MeusPedidosDesktopIcon tipo='BUTTON_PRIMARY' />
                        {`Minha Conta`}
                    </Button>
                </Box>
            )}
        </>
    );
});
